export default "__VITE_ASSET__0kXtTEN1__"